export default function CsharpCallMethods() {
  return (
    <h2>Csharp Call Methods</h2>
  );
}
